module.exports = __webpack_public_path__ + "TB_Powerdown_Melody_A.wav.b5343875.mp3";


//////////////////
// WEBPACK FOOTER
// ./client/components/sounds/power_down/TB_Powerdown_Melody_A.wav.mp3
// module id = 498
// module chunks = 0